import { Link } from "@tanstack/react-router";
import { AppIcon } from "@wilco/ui";
import { useCan } from "../auth.ts";
import { t } from "../i18n.ts";
import { visibleSections } from "./sections.ts";
import { TargetLink } from "./targets.tsx";

/**
 * Разделы с иконками: колонка слева на ПК, шторка на телефоне. Текущий
 * пункт на сером с оранжевой полосой, как меню chmk_ui.
 */
export function SectionNav({ onNavigate }: { onNavigate?: () => void }) {
  const can = useCan();
  return (
    <nav className="nav" aria-label={t("shell.sections")}>
      <ul className="nav-list">
        <li>
          <Link to="/" className="nav-item" activeOptions={{ exact: true }} onClick={onNavigate}>
            <AppIcon name="overview" size={28} />
            <span className="nav-label">{t("section.desk")}</span>
          </Link>
        </li>
        {visibleSections(can).map((s) => (
          <li key={s.id}>
            <TargetLink dest={s.target} className="nav-item" onClick={onNavigate}>
              <AppIcon name={s.icon} size={28} />
              <span className="nav-label">{t(s.label)}</span>
            </TargetLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
